import React, { Fragment } from 'react';
import { TextField, Select } from 'components/form/Formik/index';
import { INPUT_OPTIONS } from 'constant/form-builder';
import { makeStyles } from '@material-ui/core/styles';
import QuestionRadioOptions from './QuestionRadioOptions';
import HelpContent from './HelpContent';

const useStyles = makeStyles(() => ({
  root: {
    '& .select': {
      marginBottom: 8,
    },
  },
  formControl: {
    margin: 0,
    minWidth: 180,
  },
}));

const QuestionBlock = ({ index, block, name }) => {
  const classes = useStyles();
  const questionType = block?.questionType;
  const prefix = name ? name : `blocks.${index}`;

  return (
    <div className={classes.root}>
      <Select className={classes.formControl} name={`${prefix}.questionType`}>
        {INPUT_OPTIONS.map((i) => (
          <option value={i.value} key={i.value}>
            {i.label}
          </option>
        ))}
      </Select>
      <TextField name={`${prefix}.question`} placeholder="Question" />
      <TextField
        multiline
        name={`${prefix}.placeholder`}
        placeholder="Optional placeholder/help text"
      />
      <HelpContent name={`${prefix}.helpContent`} />
      {['radio', 'checkbox'].includes(questionType) && (
        <QuestionRadioOptions name={prefix} />
      )}
    </div>
  );
};

export default React.memo(QuestionBlock);
